import { FC, useContext, useEffect, useState } from "react";
import Select, { GroupBase, OptionsOrGroups } from "react-select";
import { useForm, Controller } from "react-hook-form";
import { format, parse } from "date-fns";

// import HubInputField from "src/components/inputType";
import StatsReports from "../../statsReports";

import { PatientFiltersState } from "src/pages/patient/types";
import { StatisticsProps } from "./types";
import DatePicker from "react-datepicker";
import ReactInputMask from "react-input-mask";
import { AuthContext } from "src/context/authContext";
import { isNotKAMUser, isPhiEligible } from "src/helpers";



const PatientFilter: FC<StatisticsProps> = ({ updateQueryParams, defaultQueryParams, practiceDropdown, doctorDropdown }): JSX.Element => {
  const { isManufacturer ,userData} = useContext(AuthContext)
  const [hasAppliedFilters, setHasAppliedFilters] = useState(false);

  const { control, handleSubmit, reset, getValues, watch } = useForm<PatientFiltersState>({
    mode: 'all',
    defaultValues: defaultQueryParams,
  });
  const start_date = watch("start_date");
  const end_date = watch("end_date");

  const [startOpen, setStartOpen] = useState(false);
  const [endOpen, setEndOpen] = useState(false);

  const closeDatePickers = () => {
    setStartOpen(false);
    setEndOpen(false);
  };

  useEffect(() => {
    if (!defaultQueryParams) return;
    reset(defaultQueryParams);
  }, [defaultQueryParams, reset]);
 

  const searchForStats = (values: PatientFiltersState) => {
    const updatedValues = {
      ...defaultQueryParams,
      ...values,
      role: defaultQueryParams?.role || "",
      id: defaultQueryParams?.id || "",
      global_doctor_id:
        values.global_doctor_id ?
          (typeof values.global_doctor_id === "string" ? values.global_doctor_id : (values.global_doctor_id as unknown as { value: string; label: string; }).value)
          : "",
      practice_id:
        values.practice_id ?
          (typeof values.practice_id === "string" ? values.practice_id : (values.practice_id as unknown as { value: string; label: string; }).value)
          : "",
    };

    updateQueryParams(updatedValues, false);
    setHasAppliedFilters(true);
  };

  const clearFormData = () => {
    const values = {
      ...defaultQueryParams,
      start_date: format((new Date()).setDate((new Date()).getDate() - 60), "yyyy-MM-dd"),
      end_date: format((new Date()).setDate((new Date()).getDate() + 1), "yyyy-MM-dd"),
      practice_id: "",
      global_doctor_id: "",
      case_id: "",
      global_patient_id: "",
      patient_name: "",
    };

    reset(values);
    updateQueryParams(getValues(), true);
    setHasAppliedFilters(false);
  };

  return (
    <form onSubmit={handleSubmit(searchForStats)}>
      <div className="row g-2 statistics-filter ">
        <div className="col date-col position-relative">
          <Controller
            name="start_date"
            control={control}
            defaultValue=""
            render={({ field }) => (
             <> <DatePicker
                selected={field.value.length > 0 ? parse(field.value, "yyyy-MM-dd", new Date()) : null}
                onChange={(date) => date ? field.onChange(format(date, "yyyy-MM-dd")) : ""}
                customInput={
                  <ReactInputMask mask="99/99/9999">{(inputProps: {}) =>
                    <input {...inputProps} />}
                  </ReactInputMask>
                }
                className="form-control rounded-1" wrapperClassName="w-100"
                placeholderText="mm/dd/yyyy"
                dateFormat="MM/dd/yyyy"
                showMonthDropdown
                showYearDropdown
                maxDate={end_date ? new Date(end_date) : undefined}
                open={startOpen}
                onFocus={() => {
                  setStartOpen(true);
                  setEndOpen(false);
                }}
                onClickOutside={() => setStartOpen(false)}
                onSelect={() => setStartOpen(false)}
              />
              <i
                                            className="bi bi-calendar position-absolute"
                                            style={{
                                                right: "10px",
                                                top: "50%",
                                                transform: "translateY(-50%)",
                                                pointerEvents: "none",
                                            }}
                                        ></i>
                                        </>
            )}
          />
        </div>
        <div className="col date-col position-relative">
          <Controller
            name="end_date"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <><DatePicker
                selected={field.value.length > 0 ? parse(field.value, "yyyy-MM-dd", new Date()) : null}
                onChange={(date) => date ? field.onChange(format(date, "yyyy-MM-dd")) : ""}
                customInput={<ReactInputMask mask="99/99/9999">{(inputProps: {}) =>
                  <input {...inputProps} />}</ReactInputMask>}
                className="form-control rounded-1" wrapperClassName="w-100"
                placeholderText="mm/dd/yyyy"
                dateFormat="MM/dd/yyyy"
                showMonthDropdown
                showYearDropdown
                minDate={start_date ? new Date(start_date) : undefined}
                open={endOpen}
                onFocus={() => {
                  setEndOpen(true);
                  setStartOpen(false);
                }}
                onClickOutside={() => setEndOpen(false)}
                onSelect={() => setEndOpen(false)}
              />
              <i
                                            className="bi bi-calendar position-absolute"
                                            style={{
                                                right: "10px",
                                                top: "50%",
                                                transform: "translateY(-50%)",
                                                pointerEvents: "none",
                                            }}
                                        ></i>
                                        </>
            )}
          />
        </div>
        <div className="col filters-col">

          <Controller
            name="practice_id"
            control={control}
            defaultValue=""
            render={({ field, fieldState: { error } }) => (
              <Select
                isClearable={true}
                isSearchable={true}
                options={
                  (practiceDropdown && practiceDropdown.length > 0 ?
                    practiceDropdown.map((item) => ({
                      value: item.id.toString(),
                      label: item.name
                    }))
                    : []
                  ) as unknown as OptionsOrGroups<string, GroupBase<string>>
                }
                id="practice_id"
                {...field}
                placeholder="Select Practice..."
                value={(() => {
                  if (field.value) {
                    const foundPrac = practiceDropdown?.find((prac) => prac.id.toString() === ((field.value as unknown as { value: string; })?.value || field.value));
                    return foundPrac ? { label: foundPrac.name, value: Number(foundPrac.id) } : "";
                  } else
                    return "";
                })()}
                onChange={(val) => {
                  if (val) field.onChange(val)
                  else {
                    field.onChange("")
                    if (hasAppliedFilters) {
                      searchForStats({ ...getValues(), practice_id: "" });
                    }
                  }
                }}
              />
            )}
          />
            {/*<HubInputField*/}
            {/*    inputId="practice_id"*/}
            {/*    isRequired={true}*/}
            {/*    isRowBased={true}*/}
            {/*    isRowInsideAnother={true}*/}
            {/*    field={field}*/}
            {/*    error={error}*/}
            {/*    isDropdown={true}*/}
            {/*    isSearchable={true}*/}
            {/*    inputPlaceholder="Select Practice..."*/}
            {/*    dropdownData={(*/}
            {/*        filteredPracticeListing &&*/}
            {/*        filteredPracticeListing.length > 0 ?*/}
            {/*            filteredPracticeListing.map((item) => ({*/}
            {/*                value: item.id.toString(),*/}
            {/*                label: item.name*/}
            {/*            }))*/}
            {/*            : []*/}
            {/*    ) as unknown as OptionsOrGroups<string, GroupBase<string>>}*/}
            {/*/>*/}
        </div>
        <div className="col filters-col">
          <Controller
            name="global_doctor_id"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <Select
                isClearable={true}
                isSearchable={true}
                options={
                  (doctorDropdown && doctorDropdown.length > 0 ?
                      doctorDropdown.map((item) => ({
                        value: item.id.toString(),
                        label: item.name
                      }))
                    : []
                  ) as unknown as OptionsOrGroups<string, GroupBase<string>>
                }
                id="global_doctor_id"
                {...field}
                placeholder="Select Doctor..."
                value={(() => {
                  if (field.value) {
                    // console.log(field.value)
                    const foundDoc = doctorDropdown?.find((doc) => doc.id.toString() === ((field.value as unknown as { value: string; })?.value || field.value));
                    // console.log({ foundDoc });
                    return foundDoc ? { label: foundDoc.name, value: foundDoc.id } : "";
                  } else
                    return "";
                })()}
                onChange={(val) => {
                  if (val) field.onChange(val)
                  else {
                    field.onChange("")
                    if (hasAppliedFilters) {
                      searchForStats({ ...getValues(), global_doctor_id: "" });
                    }
                  }
                }}
              />
            )}
          />
            {/*<HubInputField*/}
            {/*    inputId="global_doctor_id"*/}
            {/*    isRequired={true}*/}
            {/*    isRowBased={true}*/}
            {/*    isRowInsideAnother={true}*/}
            {/*    field={field}*/}
            {/*    error={error}*/}
            {/*    isDropdown={true}*/}
            {/*    isSearchable={true}*/}
            {/*    inputPlaceholder="Select Doctor..."*/}
            {/*    dropdownData={(*/}
            {/*        filteredDocListing &&*/}
            {/*        filteredDocListing.length > 0 ?*/}
            {/*            filteredDocListing.map((item) => ({*/}
            {/*                value: item.id.toString(),*/}
            {/*                label: item.name*/}
            {/*            }))*/}
            {/*            : []*/}
            {/*    ) as unknown as OptionsOrGroups<string, GroupBase<string>>}*/}
            {/*/>*/}
        </div>
        <div className="col date-col">
          <Controller
            name="global_patient_id"
            control={control}
            defaultValue=""
            render={({ field }) => (
              // <HubInputField
              //   inputId="global_patient_id"
              //   isRowBased={false}
              //   isRequired={false}
              //   field={field}
              //   inputPlaceholder="Pt. ID"
              // />
              <input className="form-control" type={"text"} id={'global_patient_id'} placeholder={'Pt. ID'}  {...field} onFocus={closeDatePickers} />

            )}
          />
        </div>
        <div className="col date-col">
          <Controller
            name="case_id"
            control={control}
            defaultValue=""
            render={({ field }) => (
              // <HubInputField
              //   inputId="case_id"
              //   isRowBased={false}
              //   isRequired={false}
              //   field={field}
              //   inputPlaceholder="Case ID"
              // />
              <input className="form-control" type={"text"} id={'case_id'} placeholder={'Case ID'}  {...field} onFocus={closeDatePickers} />
            )}
          />
        </div>
        {isPhiEligible(userData?.ref_type || "") && (
          <div className="col date-col">
            <Controller
              name="patient_name"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <input className="form-control" type={"text"} id={'patient_name'} placeholder={'Patient Name'} {...field} onFocus={closeDatePickers} />
              )}
            />
          </div>
        )}
        <div className="col filter-buttons d-flex gap-2">
            <button type="submit" className="btn btn-blue text-nowrap">
                <i className="fas fa-sync-alt"></i> Refresh
            </button>
            <button type="button" onClick={clearFormData} className="btn btn-light text-nowrap">
                Clear
            </button>
        </div>
      </div>
      {isManufacturer && userData && isNotKAMUser(userData.ref_type) && <StatsReports getValues={getValues} />}
    </form>
  );
};

export default PatientFilter;
